import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import Drawer from '../drawer/index';
import PbsTreeView from '../search/pbs_tree_view/index';
import { getPbsTreeViewOpened } from '../../redux/reducers/ui';
import { getSelectedProject } from '../../redux/selectors/project';
import { Project } from '../../models/project';

interface LeftNavigationProps extends RouteComponentProps {
    pbsTreeViewOpened: boolean,
    selectedProject?: Project,
}

class LeftNavigation extends React.Component<LeftNavigationProps> {
    render() {
        const { location, pbsTreeViewOpened, selectedProject } = this.props;
        const showPbsTreeView = location.pathname === '/dashboard' && pbsTreeViewOpened && !!selectedProject?.hasTreeView;

        return showPbsTreeView ? <PbsTreeView /> : <Drawer />;
    }
}

const mapStateToProps = createStructuredSelector({
    pbsTreeViewOpened: getPbsTreeViewOpened,
    selectedProject: getSelectedProject,
});

export default connect(mapStateToProps)(withRouter(LeftNavigation));